import React, { useState, useEffect } from 'react';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import Select from '@mui/material/Select';

const remarksOptions = [
    { value: "Poor", id: "poor", score: 0.2 },
    { value: "Below Average", id: "belowaverage", score: 0.4 },
    { value: "Average", id: "average", score: 0.6 },
    { value: "Good", id: "good", score: 0.8 },
    { value: "Perfect", id: "perfect", score: 1 }
  ];

  
const SelectEvaluateComponent = (props) => {
    const [selectedValue, setSelectedValue] = useState(null);

    // useEffect(() => {        
    //     if (props.defaultSelected && !selectedValue) {
    //         handleOnChange(props.defaultSelected);            
    //     } else {
    //         handleOnChange(selectedValue);
    //     }
    // }, [props.defaultSelected]);


    const handleOnChange = (itemData) => {
        setSelectedValue(itemData);
        if (itemData && props.fetchBySelectedValue) {
          props.fetchBySelectedValue(itemData);
        }
    };

    return (
        <FormControl sx={{ m: 1 }} fullWidth size="small">
            <InputLabel id="demo-multiple-name-label">Select an option</InputLabel>
            <Select
                placeholder="Select an option"
                disabled={props.disableVal ? props.disableVal : false}
                value={selectedValue}                
                renderValue={(selected) => `${selected.value}`}
                input={<OutlinedInput label="Select an option" />}
                sx={{borderRadius: 20, borderColor: '#DB8829', color: '#DB8829', fontWeight: '500', '@media (min-width: 1636px)': {
                    fontSize: '1.4rem',
                    mt: 0.5
                  }}}
            >
                {remarksOptions.map((itemData, index) => (
                    <MenuItem sx={{color: '#DB8829', fontSize: '0.8rem', fontWeight: '500','@media (min-width: 1636px)': {fontSize: '1.2rem'} }} key={`${index}_Class`} value={itemData} onClick={() => handleOnChange(itemData)}>
                        {itemData.value}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}

export default SelectEvaluateComponent;